import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DesChallanService {

  constructor(public http: HttpClient) { }

  public getEducationList(appId,acronym): Observable<any> {
    if(acronym == 'des'){
      return this.http.get(environment.BASE_URL_DES + `${acronym}/getEducationList/`+appId)
    }else if(acronym =='desf'){
      return this.http.get(environment.BASE_URL_DES + `${acronym}/getEducation/`)

    }
  }  
  public checkPaymentMethod(appId,acronym): Observable<any>
  {
    return this.http.get(environment.BASE_URL_DES + `${acronym}/checkPaymentMethod/`+appId)
  }
  
  public getInstruction(acronym):Observable<any>{
    return this.http.get(environment.BASE_URL_DES+`${acronym}/getOnlineInstructions`)
  }
  public savePaymentMethod(payload,acronym): Observable<any>
    {
      return this.http.post(environment.BASE_URL_DES + `${acronym}/savePaymentMethod`,payload)
    }

  public saveOnlinePayment(payload,acronym): Observable<any> {
    return this.http.post(environment.BASE_URL_DES+`${acronym}/saveOnlinePayment`,payload)
  }

  public saveDesfPayment(payload): Observable<any> {
    return this.http.post(environment.BASE_URL_DES+'desf/savePayment',payload)
  }

  public savePayment(payload,acronym): Observable<any> {
    return this.http.post(environment.BASE_URL_DES+`${acronym}/savePayment`,payload)
  }
  public claimTask(taskName,appId,acronym): Observable<any> {
    return this.http.get(environment.BASE_URL_DES + `${acronym}/claimTask/`+taskName+'/'+appId)
  }

  downloadPdf(payload,formName):Observable<any>{
    return this.http.post(environment.BASE_URL_COMMON+'misc/reportGeneration/DAS/'+formName+'/pdf',payload);
  }

  public getProfessionalDegreesList():Observable<any>{
    return this.http.get(environment.BASE_URL_DES+'des/getProfessionalDegrees/')
  }

  public getAppData(appId,acryonym):Observable<any>{
    return this.http.get(environment.BASE_URL_DES + `${acryonym}/getAppData/`+appId)

  }
}
